import { createAction, props } from '@ngrx/store';

import { RestAuditModel } from '@shared/interfaces/audit.interface';
import { RestRenewalModel, RestUnitRenewalTargetModel } from '@shared/interfaces/renevals.interface';

/* Load Renewals list */
export const loadRenewalsList = createAction('[Renewals] load renewals list', props<{ propertyId: number }>());
export const loadRenewalsListSucceded = createAction(
  '[Renewals] load renewals list succeded',
  props<{ renewalsList: RestRenewalModel[] }>()
);
export const loadRenewalsListFailure = createAction('[Renewals] load renewals list failure');

/* Load Renewal details */
export const loadRenewalDetails = createAction('[Renewals] load renewal details', props<{ renewalId: number }>());
export const loadRenewalDetailsSucceded = createAction(
  '[Renewals] load renewal details succeded',
  props<{ renewalDetails: RestRenewalModel }>()
);
export const loadRenewalDetailsFailure = createAction('[Renewals] load renewal details failure');

/* Load RenewalStrategyForUnit */
export const loadRenewalStrategyForUnit = createAction(
  '[Renewals] load renewal strategy for unit',
  props<{ unitId: number }>()
);
export const loadRenewalStrategyForUnitSucceded = createAction(
  '[Renewals] load renewal strategy for unit succeeded',
  props<{ unitTypeRentTarget: RestUnitRenewalTargetModel }>()
);
export const loadRenewalStrategyForUnitFailed = createAction('[Renewals] load renewal strategy for unit failed');

/* Save Renewal details */
export const saveRenewalDetails = createAction(
  '[Renewals] save renewal details',
  props<{ renewalModel: RestRenewalModel }>()
);
export const saveRenewalDetailsSucceded = createAction('[Renewals] save renewal details succeded');
export const saveRenewalDetailsFailure = createAction('[Renewals] save renewal details failure');

/* get changes history */
export const getRenewalChangesHistory = createAction('[Renewals] get changes history', props<{ objectId: number }>());
export const getRenewalChangesHistorySuccess = createAction(
  '[Renewals] get changes history success',
  props<{ auditModelList: RestAuditModel[] }>()
);
export const getRenewalChangesHistoryFailure = createAction('[Renewals] get changes history failure');
